import { type ProductData } from "~/models/ProductData";
import { resolveUrl } from "~/utils/url/urlResolver";
import { prepareRestrictionValue } from "./utils/augmentPDPUrlWithRestriction";
import { usePackageRestrictionContext } from "./PackageRestrictionContext";
import { PURCHASE_PLACE_PARAM, PURCHASE_TYPE_PARAM } from "~/ProductDetails/components/ProductSummary/PdpSummaryHelper";
import { usePurchasePlace } from "~/feature/Analytics/ga/recommendations/RecommendationContexts";
import type { PurchasePlace, PurchaseType } from "~/feature/Analytics/ga/recommendations/types";
import { PDP_RESTRICTION_URL_PARAM } from "./utils/constants";

export const useProductDetailsUrl = (
  productData: Pick<ProductData, "url" | "sapMaterialNumber">,
  reco_type?: PurchaseType,
  external_reco_place?: PurchasePlace,
  additionalParams: Record<string, string> = {},
) => {
  const reco_place = usePurchasePlace();
  const restrictedCode = usePackageRestrictionContext();

  const url = resolveUrl(productData.url);

  if (!url) {
    return url;
  }

  if (restrictedCode) {
    additionalParams[PDP_RESTRICTION_URL_PARAM] = prepareRestrictionValue(
      productData.sapMaterialNumber + restrictedCode,
    );
  }
  if (reco_type) {
    additionalParams[PURCHASE_PLACE_PARAM] = external_reco_place ?? reco_place;
    additionalParams[PURCHASE_TYPE_PARAM] = reco_type;
  }

  const urlObj = new URL(url.startsWith("/") ? window.location.origin + url : url);
  const params = urlObj.searchParams;
  Object.entries(additionalParams).forEach(([key, value]) => {
    params.set(key, value);
  });
  return urlObj.toString();
};
